import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
export var getSettingEdgeCacheAATest = function() {
    return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getSettingValueWithoutAssignment("EDGE_CACHE_AA_TEST_230629", false));
};
